module.exports = __webpack_public_path__ + "media/images/emoticons/school-1f8b2ebd0ab744a412641417ebc1bc72.gif";